import { __decorate, __metadata } from 'tslib';
import { Input, HostBinding, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';

/**
 * This component is a [Material-style bottom navigation bar]{@link https://material.io/design/components/bottom-navigation.html}.
 * It receives an array of [BottomNavItems]{@link BottomNavItem} in order to render navigation buttons.
 * With [Material theming]{@link https://github.com/latusinski/ngx-drawer-layout#enabling-material-theming}
 * enabled, this component changes its style, when the {@link color} property.
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/material/toolbar';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@angular/router';
import * as ɵngcc4 from '@angular/material/core';
import * as ɵngcc5 from '@angular/material/icon';

const _c0 = function (a0) { return { exact: a0 }; };
function BottomNavComponent_ngx_bottom_nav_button_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ngx-bottom-nav-button", 2);
} if (rf & 2) {
    const i_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("hideLabel", ctx_r0.hideLabels)("routerLink", i_r1.routerLink)("routerLinkActiveOptions", ɵngcc0.ɵɵpureFunction1(5, _c0, i_r1.exact))("label", i_r1.label)("icon", i_r1.icon);
} }
let BottomNavComponent = class BottomNavComponent {
    constructor() {
        /**
         * Navigation items, which are rendered inside the navigation bar.
         */
        this.items = [];
    }
    get colorPrimary() {
        return this.color === 'primary';
    }
    get accentPrimary() {
        return this.color === 'accent';
    }
    get warnPrimary() {
        return this.color === 'warn';
    }
    /**
     * Returns true if the length of {@link items} is greater than 4, which hides labels on inactive items.
     */
    get hideLabels() {
        return this.items.length > 4;
    }
};
BottomNavComponent.ɵfac = function BottomNavComponent_Factory(t) { return new (t || BottomNavComponent)(); };
BottomNavComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BottomNavComponent, selectors: [["ngx-bottom-nav"]], hostVars: 6, hostBindings: function BottomNavComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("color-primary", ctx.colorPrimary)("color-accent", ctx.accentPrimary)("color-warn", ctx.warnPrimary);
    } }, inputs: { items: "items", color: "color" }, decls: 2, vars: 2, consts: [[3, "color"], ["routerLinkActive", "active", 3, "hideLabel", "routerLink", "routerLinkActiveOptions", "label", "icon", 4, "ngFor", "ngForOf"], ["routerLinkActive", "active", 3, "hideLabel", "routerLink", "routerLinkActiveOptions", "label", "icon"]], template: function BottomNavComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "mat-toolbar", 0);
        ɵngcc0.ɵɵtemplate(1, BottomNavComponent_ngx_bottom_nav_button_1_Template, 1, 7, "ngx-bottom-nav-button", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("color", ctx.color);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.items);
    } }, directives: function () { return [ɵngcc1.MatToolbar, ɵngcc2.NgForOf, BottomNavButtonComponent, ɵngcc3.RouterLinkActive, ɵngcc3.RouterLink]; }, styles: ["[_nghost-%COMP%]{--ngx-bottom-nav-background-color:transparent;display:block;width:100%}mat-toolbar[_ngcontent-%COMP%]{display:flex;justify-content:center;height:56px;padding:0;background:var(--ngx-bottom-nav-background-color);overflow:hidden}mat-toolbar[_ngcontent-%COMP%]   ngx-bottom-nav-button[_ngcontent-%COMP%]{height:100%;flex:1 1 auto}"] });
__decorate([
    Input(),
    __metadata("design:type", Array)
], BottomNavComponent.prototype, "items", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], BottomNavComponent.prototype, "color", void 0);
__decorate([
    HostBinding('class.color-primary'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], BottomNavComponent.prototype, "colorPrimary", null);
__decorate([
    HostBinding('class.color-accent'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], BottomNavComponent.prototype, "accentPrimary", null);
__decorate([
    HostBinding('class.color-warn'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], BottomNavComponent.prototype, "warnPrimary", null);

/**
 * This component is a Material-style bottom navigation button.
 * It consists of an icon and a descriptive label.
 * *It should only be used by this library's internals.*
 */
let BottomNavButtonComponent = class BottomNavButtonComponent {
};
BottomNavButtonComponent.ɵfac = function BottomNavButtonComponent_Factory(t) { return new (t || BottomNavButtonComponent)(); };
BottomNavButtonComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BottomNavButtonComponent, selectors: [["ngx-bottom-nav-button"]], inputs: { hideLabel: "hideLabel", icon: "icon", label: "label" }, decls: 5, vars: 6, consts: [["matRipple", "", "matRippleRadius", "48", 1, "ngx-bottom-nav-button", 3, "matRippleCentered", "matRippleUnbounded"], [1, "label"]], template: function BottomNavButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "a", 0);
        ɵngcc0.ɵɵelementStart(1, "mat-icon");
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 1);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("label-hidden", ctx.hideLabel);
        ɵngcc0.ɵɵproperty("matRippleCentered", true)("matRippleUnbounded", true);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.icon);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
    } }, directives: [ɵngcc4.MatRipple, ɵngcc5.MatIcon], styles: ["[_nghost-%COMP%]{--ngx-bottom-nav-button-color:rgb(100, 100, 100);--ngx-bottom-nav-button-active-color:#000;min-width:80px;max-width:168px;cursor:pointer;outline:0;border:none;background:0 0;-webkit-tap-highlight-color:transparent;font-weight:400}.active[_nghost-%COMP%]{--ngx-bottom-nav-button-color:var(--ngx-bottom-nav-button-active-color)}a[_ngcontent-%COMP%]{color:var(--ngx-bottom-nav-button-color);text-decoration:none}.ngx-bottom-nav-button[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:center;justify-content:center;cursor:pointer;padding:8px 12px 12px;height:calc(100% - 20px)}.active[_nghost-%COMP%]   .ngx-bottom-nav-button[_ngcontent-%COMP%]:not(.label-hidden){padding-top:7px}.label[_ngcontent-%COMP%]{font-size:12px;line-height:12px}.active[_nghost-%COMP%]   .label[_ngcontent-%COMP%]{font-size:13px;line-height:13px}[_nghost-%COMP%]:not(.active)   .ngx-bottom-nav-button.label-hidden[_ngcontent-%COMP%]{padding-top:16px;padding-bottom:16px;height:calc(100% - 32px)}[_nghost-%COMP%]:not(.active)   .label-hidden[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{display:none}"] });
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], BottomNavButtonComponent.prototype, "hideLabel", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], BottomNavButtonComponent.prototype, "icon", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], BottomNavButtonComponent.prototype, "label", void 0);

let BottomNavModule = class BottomNavModule {
};
BottomNavModule.ɵfac = function BottomNavModule_Factory(t) { return new (t || BottomNavModule)(); };
BottomNavModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BottomNavModule });
BottomNavModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            MatIconModule,
            MatRippleModule,
            MatToolbarModule,
            RouterModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BottomNavComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-bottom-nav',
                template: "<mat-toolbar [color]=\"color\">\n  <ngx-bottom-nav-button\n    *ngFor=\"let i of items\"\n    [hideLabel]=\"hideLabels\"\n    [routerLink]=\"i.routerLink\"\n    routerLinkActive=\"active\"\n    [routerLinkActiveOptions]=\"{exact: i.exact}\"\n    [label]=\"i.label\"\n    [icon]=\"i.icon\"\n  ></ngx-bottom-nav-button>\n</mat-toolbar>\n",
                styles: [":host{--ngx-bottom-nav-background-color:transparent;display:block;width:100%}mat-toolbar{display:flex;justify-content:center;height:56px;padding:0;background:var(--ngx-bottom-nav-background-color);overflow:hidden}mat-toolbar ngx-bottom-nav-button{height:100%;flex:1 1 auto}"]
            }]
    }], function () { return []; }, { items: [{
            type: Input
        }], colorPrimary: [{
            type: HostBinding,
            args: ['class.color-primary']
        }], accentPrimary: [{
            type: HostBinding,
            args: ['class.color-accent']
        }], warnPrimary: [{
            type: HostBinding,
            args: ['class.color-warn']
        }], color: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BottomNavButtonComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-bottom-nav-button',
                template: "<a\n  class=\"ngx-bottom-nav-button\"\n  [class.label-hidden]=\"hideLabel\"\n  matRipple\n  [matRippleCentered]=\"true\"\n  matRippleRadius=\"48\"\n  [matRippleUnbounded]=\"true\"\n>\n  <mat-icon>{{icon}}</mat-icon>\n  <div class=\"label\">{{label}}</div>\n</a>\n",
                styles: [":host{--ngx-bottom-nav-button-color:rgb(100, 100, 100);--ngx-bottom-nav-button-active-color:#000;min-width:80px;max-width:168px;cursor:pointer;outline:0;border:none;background:0 0;-webkit-tap-highlight-color:transparent;font-weight:400}:host(.active){--ngx-bottom-nav-button-color:var(--ngx-bottom-nav-button-active-color)}a{color:var(--ngx-bottom-nav-button-color);text-decoration:none}.ngx-bottom-nav-button{display:flex;flex-direction:column;align-items:center;justify-content:center;cursor:pointer;padding:8px 12px 12px;height:calc(100% - 20px)}:host(.active) .ngx-bottom-nav-button:not(.label-hidden){padding-top:7px}.label{font-size:12px;line-height:12px}:host(.active) .label{font-size:13px;line-height:13px}:host(:not(.active)) .ngx-bottom-nav-button.label-hidden{padding-top:16px;padding-bottom:16px;height:calc(100% - 32px)}:host(:not(.active)) .label-hidden .label{display:none}"]
            }]
    }], null, { hideLabel: [{
            type: Input
        }], icon: [{
            type: Input
        }], label: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BottomNavModule, { declarations: function () { return [BottomNavComponent, BottomNavButtonComponent]; }, imports: function () { return [CommonModule,
        MatIconModule,
        MatRippleModule,
        MatToolbarModule,
        RouterModule]; }, exports: function () { return [BottomNavComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BottomNavModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    BottomNavComponent,
                    BottomNavButtonComponent
                ],
                imports: [
                    CommonModule,
                    MatIconModule,
                    MatRippleModule,
                    MatToolbarModule,
                    RouterModule
                ],
                exports: [BottomNavComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of bottom-nav
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BottomNavComponent, BottomNavModule, BottomNavButtonComponent as ɵa };

//# sourceMappingURL=ngx-bottom-nav.js.map